import React from 'react'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import { BillingColumns } from '../details-container/BillingColumns'
import { DescriptionMode } from '../details-container/DescriptionMode'
import DetailsBillingSection from '../details-container/detail-billing-sections/details-billing-section/DetailsBillingSection'
import { SingleLinePriceClientPricingItem } from '../pricing-item-details/single-line-price/SingleLinePrice'
import {
  ClientPricingItemTypeEnum,
  ProposalDetailsPlanningPlanningItemFragment,
} from '../../../../../lib/graphql'
import { useDateFormatter } from '../../../../../lib/hooks'

export interface IOnClickPlanningItem {
  date: Date
  clientPricingItem: SingleLinePriceClientPricingItem
}
interface IProposalDetailsPlanningProps {
  clientPlanningItemsByDates: ProposalDetailsPlanningPlanningItemFragment[]
  onClickLinePrice?: ({ clientPricingItem, date }: IOnClickPlanningItem) => void
  descriptionMode?: DescriptionMode
  isModal?: boolean
}

const ProposalDetailsPlanning = ({
  clientPlanningItemsByDates,
  onClickLinePrice,
  descriptionMode = DescriptionMode.toggable,
  isModal = false,
}: IProposalDetailsPlanningProps) => {
  const intl = useIntl()
  const dateFormatter = useDateFormatter()
  return (
    <div className={s.planningContainer}>
      {clientPlanningItemsByDates.map((clientPlanningItemsByDate) => (
        <DetailsBillingSection
          key={
            clientPlanningItemsByDate.date
              ? dateFormatter.format({
                  date: clientPlanningItemsByDate.date,
                  formatString: 'fullDate',
                })
              : 'no date'
          }
          title={{
            label: clientPlanningItemsByDate.date
              ? dateFormatter.format({
                  date: clientPlanningItemsByDate.date,
                  formatString: 'fullDate',
                })
              : intl.formatMessage({
                  id: 'ui.ProposalDetailsPlanning.dateNotSpecified',
                  defaultMessage: 'Date non spécifiée',
                }),
          }}
          // We set quantity to the quantity of the planning item
          clientPricingItems={clientPlanningItemsByDate.planningItems
            .map((planningItem) => planningItem.clientPricingItem)
            .filter(
              ({ type }) => type !== ClientPricingItemTypeEnum.FEES_ADJUSTMENTS,
            )}
          columns={[
            BillingColumns.description,
            BillingColumns.unit,
            BillingColumns.quantity,
            BillingColumns.unitHT,
            BillingColumns.totalHT,
            BillingColumns.totalTTC,
          ]}
          descriptionMode={descriptionMode}
          onClickLinePrice={
            onClickLinePrice
              ? (clientPricingItem) =>
                  onClickLinePrice({
                    clientPricingItem,
                    date: clientPlanningItemsByDate.date,
                  })
              : undefined
          }
          className={s.planningSection}
          isModal={isModal}
        />
      ))}
    </div>
  )
}

export default ProposalDetailsPlanning
